import _ from "lodash";
import { calculateFooterTotals, calculateTotals } from "components/shipment-review/shipment-review-grid";
import { IDetailsTotal, IRowData } from "../types";
import type { IGridEntry, IOrderCurrency } from "types/cart/shipment-review";
import { isAllocated, isMatchLocation } from "helpers/legacy-cart/bulk";

export const buildItemTotals = (rows: IRowData[], currency: IOrderCurrency): IDetailsTotal =>
    _.reduce(rows, (totals, row) => getDetailRowTotals(row, currency, totals), getTotals(currency));

export const getDetailRowTotals = (row: IRowData, currency: IOrderCurrency, totals = getTotals(currency)) => {
    // Do not include bulk units into row totals
    if (row.item?.bulkUnits?.units && !row.item?.bulkUnits?.sized) {
        return totals;
    }
    _.forEach(row.sizes, (size, id) => {
        totals.sizes[id] = totals.sizes[id] || {
            quantity: 0,
            totalWholesalePrice: 0,
            totalOriginalWholesalePrice: 0,
        };
        // check allocation match here to populate default totals for all sizes
        if (isMatchLocation(row) && size.quantity > 0) {
            const pricing = {
                quantity: size.quantity,
                wholeSalePrice: size.pricing.wholesalePrice ?? 0,
                discountedPrice: size.pricing.discountedPrice,
                originalWholesalePrice: size.pricing.originalWholesalePrice ?? 0,
                retailPrice: size.pricing.retailPrice ?? 0,
                currency: row.currency,
            };
            // TODO GV: clean up this mess
            calculateFooterTotals(totals.sizes[id], totals, pricing, size.unitsPerPack);
        }
    });
    return totals;
};

export const calculateTotalsBySizes = (entries: IGridEntry[], currency: IOrderCurrency) => {
    const totals = getTotals(currency);
    _.forEach(entries, (entry) => {
        totals.sizes[entry.size.size] = {
            quantity: (totals?.sizes[entry.size.size]?.quantity || 0) + entry?.quantity,
        };
        if (isAllocated(entry.allocated, entry.location) && entry.quantity > 0) {
            calculateTotals(entry, totals);
        }
    });
    return totals;
};

export const getTotals = (currency: IOrderCurrency): IDetailsTotal => ({
    quantity: 0,
    totalWholesalePrice: 0,
    totalRetailPrice: 0,
    totalOriginalWholesalePrice: 0,
    currency,
    sizes: {},
});
